import { useQuery } from 'react-query'
import { NestAPI, useGetBusiness } from '@marketing-milk/frontend'
import { CreativeImportListItem } from '@marketing-milk/interfaces'

/**
 * The business's last handful of imports — a way back into one you just ran.
 * Wired to the menu being open so the creatives page costs nothing until it's
 * clicked. The default staleTime of 0 means each open refetches; deliberately
 * not polled, since this is a peek rather than a monitor.
 */
export const useCreativeImportRecent = (enabled: boolean) => {
  const business = useGetBusiness()

  return useQuery<CreativeImportListItem[]>(
    ['creative-import-recent', business.id],
    async () => {
      const response = await NestAPI.get<CreativeImportListItem[]>(
        `businesses/${business.id}/creative-import/recent`
      )
      return response.data || []
    },
    { enabled }
  )
}
